import React, { useState } from 'react';
import './TestCard.css';
import { FaEye } from 'react-icons/fa';
import DetailModal from './DetailModal';

const TestCard = ({ test, isSelected, onClick }) => {
  const [showDetail, setShowDetail] = useState(false);

  const getTagClass = (type) => {
    if (type.includes('Социометрия') || type.includes('социометрия')) {
      return 'test-temp-tag test-temp-tag-sociometry';
    } else if (type.includes('Лидерство') || type.includes('лидерство')) {
      return 'test-temp-tag test-temp-tag-leadership';
    } else if (type.includes('Роль в команде') || type.includes('роль в команде')) {
      return 'test-temp-tag test-temp-tag-teamrole';
    }
    return 'test-tag';
  };

  return (
    <>
      <div className="test-card-temp-wrapper">
        <div 
          className={`test-card-temp ${isSelected ? 'selected' : ''}`} 
          onClick={onClick}
        >
          <FaEye 
            className="detail-temp-icon" 
            onClick={(e) => {
              e.stopPropagation();
              setShowDetail(true);
            }}
          />
          
          <div className="test-card-temp-content">
            <div className="test-card-temp-field">
              <div className="test-card-temp-category">ТЕСТИРОВАНИЕ</div>
              <div className="test-card-temp-title">{test.name}</div>
            </div>

            <div className="test-card-temp-field">
              <div className="test-card-temp-category">КОЛИЧЕСТВО ВОПРОСОВ</div>
              <div className="test-card-temp-value">{test.questions.length}</div>
            </div>

            <div className="test-card-temp-field">
              <div className="test-card-temp-category">ОПИСАНИЕ</div>
              <div className="test-card-temp-value">{test.description || 'Описание отсутствует'}</div>
            </div>

            <div className="test-card-temp-field">
              <div className="test-card-temp-category">ДАТА СОЗДАНИЯ</div>
              <div className="test-card-temp-value">{test.date_created || 'Дата отсутствует'}</div>
            </div>
          </div>

          <div className="test-card-temp-tags">
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {test.question_types && test.question_types.map((type, index) => (
                <span key={index} className={getTagClass(type)}>
                  {type}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {showDetail && (
        <DetailModal 
          data={test} 
          type="test" 
          onClose={() => setShowDetail(false)}
        />
      )}
    </>
  );
};

export default TestCard;